import React, { useState } from 'react';
import { Facilitator } from '.';
import { Avatar, Divider, Flex, Stack, Text, Tooltip } from '@mantine/core';
import FacilitatorItem from './FacilitatorItem';
import ModalWrapper from '../../elements/ModalWrapper';
import { ApiService } from '../../../constants';

interface FacilitatorProps {
  facilitators: Facilitator[];
}
const FacilitatorSection: React.FC<FacilitatorProps> = ({ facilitators }) => {
  const [opened, setOpened] = useState(false);
  if (facilitators.length < 1)
    return (
      <Text fw={700} fz={12} c={'gray'}>
        {' '}
        No Facilitator
      </Text>
    );

  return (
    <>
      <Tooltip.Group openDelay={300} closeDelay={100}>
        <Avatar.Group spacing="sm">
          {facilitators.length > 4
            ? facilitators.slice(0, 4).map((facilitator, i) => {
                if (i < 3) return <FacilitatorItem {...facilitator} key={i} />;
                return (
                  <FacilitatorItem
                    {...facilitator}
                    key={i}
                    type="more"
                    total={facilitators.length - 3}
                    onClick={() => setOpened(true)}
                  />
                );
              })
            : facilitators.map((facilitator, i) => {
                return <FacilitatorItem {...facilitator} key={i} />;
              })}
        </Avatar.Group>
      </Tooltip.Group>

      <ModalWrapper
        isVisible={opened}
        onClose={() => setOpened(false)}
        title="List Facilitator"
      >
        {facilitators?.map((facilitator, i) => {
          return (
            <React.Fragment key={i}>
              <Flex gap={16}>
                <Avatar
                  alt={facilitator.email}
                  src={ApiService.beelajar.getImageMoodle(
                    facilitator.urlprofile
                  )}
                  radius="xl"
                />
                <Stack gap={0}>
                  <Text fz={16} fw={700}>
                    {facilitator.facilitatorname}
                  </Text>
                  <Text fz={12} fw={600} c={'gray'}>
                    {facilitator.email}
                  </Text>
                </Stack>
              </Flex>
              {i !== facilitators.length - 1 && <Divider my={8} />}
            </React.Fragment>
          );
        })}
      </ModalWrapper>
    </>
  );
};

export default FacilitatorSection;
